import { useEffect, useState } from "react";
import OfferCard from "../../Components/OfferCard/OfferCard";
import { IBillListDTO } from "../../Interfaces/Bill";
import DeliveryNotePdfPreviewer from "../Services/DeliveryNote/PdfPreviewer";
import { useMediaQuery } from "@mui/material";
import { useGetMostRecentOfferQuery } from "../../redux/apiSlices/Bill.slice";
const ManageOffers = () => {
  const isMobile = useMediaQuery("(max-width: 1300px)");
  const { data: mostRecentOffer } = useGetMostRecentOfferQuery();
  useEffect(() => {
    if (mostRecentOffer) {
      setClickedOffer(mostRecentOffer);
    }
  }, [mostRecentOffer]);
  const [clickedOffer, setClickedOffer] = useState<IBillListDTO>();

  return (
    <>
      {isMobile && (
        <div className="w-full flex flex-col gap-4">
          <OfferCard setClickedOffer={setClickedOffer} />
          <DeliveryNotePdfPreviewer documentId={clickedOffer?.bill.document!} />
        </div>
      )}
      {!isMobile && (
        <div className="flex flex-row w-full gap-4">
          <div className="w-1/2">
            <OfferCard setClickedOffer={setClickedOffer} />
          </div>
          <div className="w-1/2">
            <DeliveryNotePdfPreviewer
              documentId={clickedOffer?.bill.document!}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ManageOffers;
